var _toConsumableArray = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/toConsumableArray");

module.exports = function (_ref) {
  var _ref$print_fn = _ref.print_fn,
      print_fn = _ref$print_fn === void 0 ? console.log.bind(console) : _ref$print_fn;
  return {
    print: function print(args) {
      return print_fn.apply(void 0, _toConsumableArray(args));
    },
    sqrt: function sqrt(a) {
      return Math.sqrt(a);
    }
  };
};